export default __webpack_public_path__ + "static/media/kvb.766b5acf.png";